import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceButton } from '../components/ChoiceButton';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
import { Microscope, Zap, Workflow, ShieldCheck } from 'lucide-react';
interface Props {
  onSelect: (value: string) => void;
  selectedValue?: string;
}
const options = [{
  id: 'expertise',
  label: 'Scientific expertise',
  icon: Microscope
}, {
  id: 'speed',
  label: 'Speed & responsiveness',
  icon: Zap
}, {
  id: 'integrated',
  label: 'Integrated capabilities',
  icon: Workflow
}, {
  id: 'gmp',
  label: 'GMP / regulatory confidence',
  icon: ShieldCheck
}];
export function SlideDecision({
  onSelect,
  selectedValue
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-28" data-id="element-470">
      <MolecularBackdrop variant="grid" data-id="element-471" />

      <div className="relative z-10 flex-1 flex flex-col justify-center" data-id="element-472">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-473">
          <span className="text-minerva-blue text-[10px] font-bold tracking-[0.25em] uppercase mb-4 block" data-id="element-474">
            Industry Pulse · 02
          </span>
          <h2 className="text-[26px] font-display font-bold text-slate-900 leading-tight mb-7" data-id="element-475">
            What matters most when selecting a CRO/CDMO partner?
          </h2>
        </motion.div>

        <div className="flex flex-col gap-3" data-id="element-476">
          {options.map((opt, i) => <ChoiceButton key={opt.id} label={opt.label} icon={opt.icon} selected={selectedValue === opt.id} onClick={() => onSelect(opt.id)} delay={0.2 + i * 0.1} data-id="element-477" />)}
        </div>
      </div>
    </motion.div>;
}